import {useSyncExternalStore} from 'react';

import {dragStore, selectJobQueue} from '../store/dragStore';

export const useJobQueue = () => useSyncExternalStore(dragStore.subscribe, selectJobQueue);
